import {css} from "@panda/css";

import {FOR_YOU_TEST_IDS} from "@pg-mono/test-ids";

import {consultantList} from "../../../application/utils/lead/get_random_consultant";
import {ForYouBannerConsultantAvatar} from "./ForYouBannerConsultantAvatar";

export const ForYouBannerConsultantsAvatars = () => {
    return (
        <div className={consultantsWrapperStyle} data-testid={FOR_YOU_TEST_IDS.FOR_YOU_BANNER_CONSULTANTS}>
            {consultantList.map((consultant, index) => (
                <ForYouBannerConsultantAvatar
                    key={consultant.fullName}
                    consultant={consultant}
                    className={index > 0 ? consultantAvatarOverlapStyle : undefined}
                    style={{zIndex: consultantList.length - index}}
                />
            ))}
        </div>
    );
};

const consultantsWrapperStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    pl: 3,

    md: {
        pl: 2
    },

    xl: {
        pl: 5
    }
});

const consultantAvatarOverlapStyle = css({
    marginLeft: "-3.2rem",

    md: {
        marginLeft: "-4rem"
    }
});
import {css} from "@panda/css";

import {FOR_YOU_TEST_IDS} from "@pg-mono/test-ids";

import {consultantList} from "../../../application/utils/lead/get_random_consultant";
import {ForYouBannerConsultantAvatar} from "./ForYouBannerConsultantAvatar";

export const ForYouBannerConsultantsAvatars = () => {
    return (
        <div className={consultantsWrapperStyle} data-testid={FOR_YOU_TEST_IDS.FOR_YOU_BANNER_CONSULTANTS}>
            {consultantList.map((consultant, index) => (
                <ForYouBannerConsultantAvatar
                    key={consultant.fullName}
                    consultant={consultant}
                    className={index > 0 ? consultantAvatarOverlapStyle : undefined}
                    style={{zIndex: consultantList.length - index}}
                />
            ))}
        </div>
    );
};

const consultantsWrapperStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    pl: 3,

    md: {
        pl: 2
    },

    xl: {
        pl: 5
    }
});

const consultantAvatarOverlapStyle = css({
    marginLeft: "-3.2rem",

    md: {
        marginLeft: "-4rem"
    }
});
